import { render, staticRenderFns } from "./DocumentTemplateEdit.vue?vue&type=template&id=61d54319&"
import script from "./DocumentTemplateEdit.vue?vue&type=script&lang=js&"
export * from "./DocumentTemplateEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports